import { UPLOAD_PROPERTY_MEDIA } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPLOAD_PROPERTY_MEDIA.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_PROPERTY_MEDIA.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPLOAD_PROPERTY_MEDIA.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
